module.exports = __webpack_public_path__ + "assets/img/d1.1d14893f.jpg";